var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNohoDlouheModraRgb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 100,
    viewBox: "0 0 265 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0424 66.4806H58.6352L40.669 43.7791V66.4806H32.9625V33.5181H41.9229L57.5215 53.713V33.5181H65.0424V66.4793V66.4806Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4859 50.0007C86.4859 39.8798 94.1003 32.9626 103.989 32.9626C113.877 32.9626 121.445 39.8798 121.445 50.0007C121.445 60.1215 113.831 67.0388 103.989 67.0388C94.147 67.0388 86.4859 60.0748 86.4859 50.0007ZM113.413 50.0007C113.413 44.4762 109.791 40.0187 103.989 40.0187C98.1865 40.0187 94.5183 44.4295 94.5183 50.0007C94.5183 55.5719 98.1852 59.9827 103.989 59.9827C109.792 59.9827 113.413 55.5719 113.413 50.0007Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.362 50.0007C196.362 39.8798 203.977 32.9626 213.865 32.9626C223.754 32.9626 231.321 39.8798 231.321 50.0007C231.321 60.1215 223.707 67.0388 213.865 67.0388C204.024 67.0388 196.362 60.0748 196.362 50.0007ZM223.289 50.0007C223.289 44.4762 219.668 40.0187 213.865 40.0187C208.063 40.0187 204.395 44.4295 204.395 50.0007C204.395 55.5719 208.062 59.9827 213.865 59.9827C219.669 59.9827 223.289 55.5719 223.289 50.0007Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.027 53.4353H150.731V66.4806H142.839V33.5181H150.731V46.4713H167.027V33.5181H174.919V66.4806H167.027V53.4353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNohoDlouheModraRgb3);
export default __webpack_public_path__ + "static/media/NOHO-dlouhe-modra_RGB 3.dd45f014da8b9555b96539ed0201fc26.svg";
export { ForwardRef as ReactComponent };